export interface TutorialProgress {
  chubIntroduction: boolean;
  chubCreateCreative: boolean;
  chubChooseAdFormat: boolean;
}

export const newUserTutorialProgress: TutorialProgress = {
  chubIntroduction: false,
  chubCreateCreative: false,
  chubChooseAdFormat: false,
};

// Testing Tutorial Progress
export const exampleTutorialProgress: TutorialProgress = {
  chubIntroduction: false,
  chubCreateCreative: false,
  chubChooseAdFormat: false,
};
